/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";

import type {
  BadRequestResponse,
  ChangePlan200,
  ChangePlanBody,
  CreateCheckoutSession200,
  CreateCheckoutSessionBody,
  CreatePortalSession200,
  ForbiddenResponse,
  GetBillingUsage200,
  GetBillingUsageParams,
  GetPagesPerPeriod200,
  InternalServerErrorResponse,
  NotFoundResponse,
  PreviewPlanChange200,
  PreviewPlanChangeBody,
  UnauthorizedResponse,
} from ".././model";

import { customInstance } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Retrieve billing usage for an organization
 */
export const getBillingUsage = (
  organizationId: string,
  params: GetBillingUsageParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetBillingUsage200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/billing/usage`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetBillingUsageQueryKey = (
  organizationId: string,
  params?: GetBillingUsageParams
) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/billing/usage`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetBillingUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getBillingUsage>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  params: GetBillingUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBillingUsage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBillingUsageQueryKey(organizationId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingUsage>>> = ({
    signal,
  }) => getBillingUsage(organizationId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!organizationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getBillingUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBillingUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBillingUsage>>
>;
export type GetBillingUsageQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetBillingUsage<
  TData = Awaited<ReturnType<typeof getBillingUsage>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  params: GetBillingUsageParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBillingUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingUsage>>,
          TError,
          Awaited<ReturnType<typeof getBillingUsage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBillingUsage<
  TData = Awaited<ReturnType<typeof getBillingUsage>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  params: GetBillingUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBillingUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBillingUsage>>,
          TError,
          Awaited<ReturnType<typeof getBillingUsage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBillingUsage<
  TData = Awaited<ReturnType<typeof getBillingUsage>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  params: GetBillingUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBillingUsage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve billing usage for an organization
 */

export function useGetBillingUsage<
  TData = Awaited<ReturnType<typeof getBillingUsage>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  params: GetBillingUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getBillingUsage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetBillingUsageQueryOptions(
    organizationId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Retrieve page per billing period data for an organization
 */
export const getPagesPerPeriod = (
  organizationId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetPagesPerPeriod200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/billing/page-per-period`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetPagesPerPeriodQueryKey = (organizationId: string) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/billing/page-per-period`,
  ] as const;
};

export const getGetPagesPerPeriodQueryOptions = <
  TData = Awaited<ReturnType<typeof getPagesPerPeriod>>,
  TError = unknown,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPagesPerPeriod>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPagesPerPeriodQueryKey(organizationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPagesPerPeriod>>
  > = ({ signal }) => getPagesPerPeriod(organizationId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!organizationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPagesPerPeriod>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPagesPerPeriodQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPagesPerPeriod>>
>;
export type GetPagesPerPeriodQueryError = unknown;

export function useGetPagesPerPeriod<
  TData = Awaited<ReturnType<typeof getPagesPerPeriod>>,
  TError = unknown,
>(
  organizationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPagesPerPeriod>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPagesPerPeriod>>,
          TError,
          Awaited<ReturnType<typeof getPagesPerPeriod>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPagesPerPeriod<
  TData = Awaited<ReturnType<typeof getPagesPerPeriod>>,
  TError = unknown,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPagesPerPeriod>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPagesPerPeriod>>,
          TError,
          Awaited<ReturnType<typeof getPagesPerPeriod>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPagesPerPeriod<
  TData = Awaited<ReturnType<typeof getPagesPerPeriod>>,
  TError = unknown,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPagesPerPeriod>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Retrieve page per billing period data for an organization
 */

export function useGetPagesPerPeriod<
  TData = Awaited<ReturnType<typeof getPagesPerPeriod>>,
  TError = unknown,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPagesPerPeriod>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPagesPerPeriodQueryOptions(
    organizationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a checkout session for billing
 */
export const createCheckoutSession = (
  organizationId: string,
  createCheckoutSessionBody?: CreateCheckoutSessionBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CreateCheckoutSession200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/billing/checkout-session`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCheckoutSessionBody,
      signal,
    },
    options
  );
};

export const getCreateCheckoutSessionMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCheckoutSession>>,
    TError,
    { organizationId: string; data: CreateCheckoutSessionBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCheckoutSession>>,
  TError,
  { organizationId: string; data: CreateCheckoutSessionBody },
  TContext
> => {
  const mutationKey = ["createCheckoutSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCheckoutSession>>,
    { organizationId: string; data: CreateCheckoutSessionBody }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return createCheckoutSession(organizationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCheckoutSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCheckoutSession>>
>;
export type CreateCheckoutSessionMutationBody = CreateCheckoutSessionBody;
export type CreateCheckoutSessionMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Create a checkout session for billing
 */
export const useCreateCheckoutSession = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCheckoutSession>>,
      TError,
      { organizationId: string; data: CreateCheckoutSessionBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createCheckoutSession>>,
  TError,
  { organizationId: string; data: CreateCheckoutSessionBody },
  TContext
> => {
  return useMutation(
    getCreateCheckoutSessionMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Create a Stripe billing portal session
 */
export const createPortalSession = (
  organizationId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CreatePortalSession200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/billing/portal-session`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getCreatePortalSessionMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPortalSession>>,
    TError,
    { organizationId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPortalSession>>,
  TError,
  { organizationId: string },
  TContext
> => {
  const mutationKey = ["createPortalSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPortalSession>>,
    { organizationId: string }
  > = (props) => {
    const { organizationId } = props ?? {};

    return createPortalSession(organizationId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePortalSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPortalSession>>
>;

export type CreatePortalSessionMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Create a Stripe billing portal session
 */
export const useCreatePortalSession = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createPortalSession>>,
      TError,
      { organizationId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createPortalSession>>,
  TError,
  { organizationId: string },
  TContext
> => {
  return useMutation(
    getCreatePortalSessionMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Preview the cost of changing subscription plan
 */
export const previewPlanChange = (
  organizationId: string,
  previewPlanChangeBody: PreviewPlanChangeBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<PreviewPlanChange200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/billing/preview-plan-change`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: previewPlanChangeBody,
      signal,
    },
    options
  );
};

export const getPreviewPlanChangeMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewPlanChange>>,
    TError,
    { organizationId: string; data: PreviewPlanChangeBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewPlanChange>>,
  TError,
  { organizationId: string; data: PreviewPlanChangeBody },
  TContext
> => {
  const mutationKey = ["previewPlanChange"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewPlanChange>>,
    { organizationId: string; data: PreviewPlanChangeBody }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return previewPlanChange(organizationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewPlanChangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewPlanChange>>
>;
export type PreviewPlanChangeMutationBody = PreviewPlanChangeBody;
export type PreviewPlanChangeMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Preview the cost of changing subscription plan
 */
export const usePreviewPlanChange = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof previewPlanChange>>,
      TError,
      { organizationId: string; data: PreviewPlanChangeBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof previewPlanChange>>,
  TError,
  { organizationId: string; data: PreviewPlanChangeBody },
  TContext
> => {
  return useMutation(getPreviewPlanChangeMutationOptions(options), queryClient);
};
/**
 * @summary Change the organization subscription plan
 */
export const changePlan = (
  organizationId: string,
  changePlanBody: ChangePlanBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ChangePlan200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/billing/change-plan`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changePlanBody,
      signal,
    },
    options
  );
};

export const getChangePlanMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePlan>>,
    TError,
    { organizationId: string; data: ChangePlanBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePlan>>,
  TError,
  { organizationId: string; data: ChangePlanBody },
  TContext
> => {
  const mutationKey = ["changePlan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePlan>>,
    { organizationId: string; data: ChangePlanBody }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return changePlan(organizationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof changePlan>>
>;
export type ChangePlanMutationBody = ChangePlanBody;
export type ChangePlanMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Change the organization subscription plan
 */
export const useChangePlan = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changePlan>>,
      TError,
      { organizationId: string; data: ChangePlanBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof changePlan>>,
  TError,
  { organizationId: string; data: ChangePlanBody },
  TContext
> => {
  return useMutation(getChangePlanMutationOptions(options), queryClient);
};
